import { FC } from 'react'
import { TopBarMainNav } from '@reapit/elements'
import { NavigationMenu } from '../types'
import { useNavigationHandler } from '../utils'
interface MainMenuItemProps extends NavigationMenu {}

/**
 * Renders a single navigation item in the top bar.
 *
 * Uses React Router’s `useHref` to generate the `href`, highlights
 * the item when it matches the active key, and calls back when clicked.
 *
 * @param onClick       Function to invoke when this menu item is clicked.
 * @param title          Text label to display for the navigation item.
 * @param href           Route path or URL this item links to.
 * @returns              A `<TopBar.NavItem>` that behaves like a link.
 */
export const MainMenuItem: FC<MainMenuItemProps> = ({ onClick, title, href }) => {
  const navHandler = useNavigationHandler(href, onClick)
  return <TopBarMainNav.Item {...navHandler}>{title}</TopBarMainNav.Item>
}
